// extracted by mini-css-extract-plugin
export default {"buttonIcon":"styles_buttonIcon__8kLDp"};